import { Component, Vue } from 'vue-property-decorator';
import AuthenticationModule from '@/store/modules/authentication.module';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AuthenticationActions } from '@/constants/actions.constants';

@Component
export default class ChangeEmailComponent extends Vue {
  public get token(): string {
    return this.$route.query.token as string;
  }

  public get newEmail(): string {
    return this.$route.query.newEmail as string;
  }

  public get email(): string {
    return this.$route.query.email as string;
  }

  public async confirmEmail(): Promise<void> {
    const authenticationModule: AuthenticationModule = getModule(
      AuthenticationModule,
      store
    );

    await authenticationModule[AuthenticationActions.confirmChangeEmailAction]({
      email: this.email,
      newEmail: this.newEmail,
      token: this.token
    });
  }
}
